/* unplugin-vue-components disabled */import { render } from "./object-viewer.vue?vue&type=template&id=36851f40&scoped=true"
import script from "./object-viewer.vue?vue&type=script&lang=js"
export * from "./object-viewer.vue?vue&type=script&lang=js"

import "./object-viewer.vue?vue&type=style&index=0&id=36851f40&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36851f40"],['__file',"src/controls/object-viewer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "36851f40"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('36851f40', __exports__)) {
    api.reload('36851f40', __exports__)
  }
  
  module.hot.accept("./object-viewer.vue?vue&type=template&id=36851f40&scoped=true", () => {
    api.rerender('36851f40', render)
  })

}


export default __exports__